module.exports = __webpack_public_path__ + "img/icon2.d52fa71f.png";